import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth"
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  QueryDocumentSnapshot,
  QuerySnapshot,
  setDoc,
  updateDoc
} from "firebase/firestore"
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes
} from "firebase/storage"
import { createContext, useContext, useState } from "react"
import { toast } from "react-toastify"
import Styled from "../Pages/Home/SectionFeedBacks/section_feedBacks.module.css"
import { settingsDefault } from "./settingsData"
import {
  ContactProps,
  FeedBack,
  FeedBacksProps,
  FileProps,
  FormatTextProps,
  imgProps,
  LandingContextType,
  LandingProviderType,
  textVariablesProps,
  webSiteProps
} from "./types"

export const LandingContext = createContext({} as LandingContextType)

function LandingProvider({ children }: LandingProviderType) {
  const [signed, setSigned] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [feedBacks, setFeedBacks] = useState<FeedBacksProps>([])
  const [feedBackActive, setFeedBackActive] = useState<FeedBack>({} as FeedBack)
  const [controllerStop, setControllerStop] = useState<boolean>(false)
  const [websiteSettings, setWebsiteSettings] =
    useState<webSiteProps>(settingsDefault)

  async function handleSignIn(
    email: string,
    password: string,
    saveDatas: boolean
  ) {
    if (email.length > 0 && password.length > 0) {
      await signInWithEmailAndPassword(getAuth(), email, password)
        .then(() => {
          setSigned(true)
          handleToggleDatasLocalStorage(email, password, saveDatas)
        })
        .catch(error => {
          if (error.code === "auth/invalid-email") {
            toast.error("Usuario invalido!")
          } else {
            console.log(error)
            toast.error("Ops! Algo deu errado.")
          }
        })
    } else {
      toast.info("Preencha todos os dados!")
    }
  }

  function handleToggleControllerStop() {
    setControllerStop(!controllerStop)
  }

  function handleCheckedLocalStorage() {
    const user = localStorage.getItem("userCrendential")
    if (user !== null && typeof JSON.parse(user) === "object") {
      const data = JSON.parse(user)
      if (data.email && data.password) {
        handleSignIn(data.email, data.password, true)
      }
    }
  }

  function handleToggleDatasLocalStorage(
    email: string,
    password: string,
    e: boolean
  ) {
    if (e) {
      localStorage.setItem(
        "userCrendential",
        JSON.stringify({
          email,
          password
        })
      )
    } else {
      if (localStorage.userCrendential) {
        localStorage.removeItem("userCrendential")
      }
    }
  }

  async function handleSignOut() {
    signOut(getAuth())
      .then(() => {
        if (localStorage.userCrendential) {
          localStorage.removeItem("userCrendential")
          setSigned(false)
        } else {
          setSigned(false)
        }
      })
      .catch(error => {
        console.log(error)
        toast.error("Ops! Falha ao sair.")
      })
  }

  function handleFormatText(props: FormatTextProps) {
    let isRunning = false
    let textarea = document.getElementsByName(props.valueState.ref)
    textarea.item(0).onselect = handleGetText

    function handleGetText(event: any) {
      let textSelect: string = event.target.value.substring(
        event.target.selectionStart,
        event.target.selectionEnd
      )

      if (!isRunning && textSelect !== undefined && textSelect.length > 0) {
        const textVariables = {
          textInput: props.valueState.value,
          inputLength: props.valueState.value.length,
          selectionLength: textSelect?.length,
          characterInit: props.valueState.value.indexOf(textSelect),
          characterEnd:
            props.valueState.value.indexOf(textSelect) + textSelect?.length,
          CharacterRestOld: props.valueState.value.slice(
            0,
            props.valueState.value.indexOf(textSelect)
          ),
          CharacterRestLater: props.valueState.value.slice(
            props.valueState.value.indexOf(textSelect) + textSelect?.length,
            props.valueState.value.length
          )
        }

        const resultCut = handleCutTextSelect(textVariables)
        const resultEnvelopTag = handleEnvelopTag(
          props.tag,
          resultCut,
          textVariables
        )
        setWebsiteSettings({
          ...websiteSettings,
          [props.valueState.ref]: {
            ref: props.valueState.ref,
            value: resultEnvelopTag,
            ToggleView: props.valueState.ToggleView
          }
        })
      }

      isRunning = true
    }
  }

  function handleCutTextSelect(textVariables: textVariablesProps) {
    const result = textVariables.textInput.slice(
      textVariables.characterInit,
      textVariables.characterEnd
    )
    return result
  }

  function handleEnvelopTag(
    tag: string,
    resultCut: string,
    textVariables: textVariablesProps
  ) {
    const valueInternal = `${textVariables.CharacterRestOld}<${tag}>${resultCut}</${tag}>${textVariables.CharacterRestLater}`

    return valueInternal
  }

  async function handleAddFeedBacks(name: string, feedBack: string) {
    if (name.length > 0 && feedBack.length > 0) {
      await addDoc(collection(getFirestore(), "feedBacks"), {
        name,
        feedBack,
        date: new Date()
      })
        .then(() => {
          toast.success("Adicionado com sucesso!")
        })
        .catch(error => {
          console.log(error)
          toast.error("Ops! algo deu errado.")
        })
    } else {
      toast.info("Preencha todos os campos!")
    }
  }

  function handleUploadImage(e: FileProps, value: imgProps) {
    if (e !== null && e.target.files !== null) {
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const storage = getStorage()
        const name = e.target.files[0].name
        const storageRef = ref(storage, `websiteImages/${name}`)

        uploadBytes(storageRef, e.target.files[0]).then(() => {
          getDownloadURL(storageRef)
            .then(url => {
              setWebsiteSettings({
                ...websiteSettings,
                [value.ref]: {
                  name,
                  file: null,
                  url,
                  ref: value.ref
                }
              })

              toast.success("Upload realizado com sucesso!")
            })
            .catch(error => {
              console.log(error)
            })
        })
      } else {
        toast.error("Formato invalido [ PNG OU JPG ]")
      }
    }
  }

  async function handleSaveSettingsWebsite() {
    if (
      websiteSettings.blog.length > 0 &&
      websiteSettings.whatsapp.length > 0 &&
      websiteSettings.prominentTitle.value.length > 0 &&
      websiteSettings.attendance.length > 0 &&
      websiteSettings.books.length > 0 &&
      websiteSettings.speeches.length > 0 &&
      websiteSettings.courses.length > 0 &&
      websiteSettings.textCurriculo.value.length > 0
    ) {
      const firestoreRef = doc(
        getFirestore(),
        "landing-page",
        "websiteSettings"
      )
      await setDoc(firestoreRef, {
        logo: {
          name: websiteSettings.logo.name,
          file: null,
          url: websiteSettings.logo.url,
          ref: websiteSettings.logo.ref
        },
        background: {
          name: websiteSettings.background.name,
          file: null,
          url: websiteSettings.background.url,
          ref: websiteSettings.background.ref
        },
        imgCurriculo: {
          name: websiteSettings.imgCurriculo.name,
          file: null,
          url: websiteSettings.imgCurriculo.url,
          ref: websiteSettings.imgCurriculo.ref
        },
        blog: websiteSettings.blog,
        whatsapp: websiteSettings.whatsapp,
        prominentTitle: {
          ref: websiteSettings.prominentTitle.ref,
          value: websiteSettings.prominentTitle.value,
          ToggleView: false
        },
        attendance: websiteSettings.attendance,
        books: websiteSettings.books,
        speeches: websiteSettings.speeches,
        courses: websiteSettings.courses,
        textCurriculo: {
          ref: websiteSettings.textCurriculo.ref,
          value: websiteSettings.textCurriculo.value,
          ToggleView: false
        }
      })
        .then(() => {
          toast.success("Salvo com sucesso!")
        })
        .catch(error => {
          console.log(error)
          toast.error("Ops! Erro ao salvar!")
        })
    } else {
      toast.info("Preencha todos os campos!")
    }
  }

  async function handleGetFeedBacks() {
    const collectionRef = query(
      collection(getFirestore(), "feedBacks"),
      orderBy("date", "desc")
    )
    onSnapshot(collectionRef, (snapshot: QuerySnapshot<DocumentData>) => {
      let newList: FeedBacksProps = []

      snapshot.docs.forEach(
        (result: QueryDocumentSnapshot<DocumentData>, index: number) => {
          const feedBack = {
            name: result.data().name,
            feedBack: result.data().feedBack,
            id: result.id,
            isActive: index === 0 ? true : false,
            date: result.data().date
          }

          newList.push(feedBack)
          index === 0 && setFeedBackActive(feedBack)
        }
      )

      setFeedBacks(newList)
    })
  }

  function handleApplyAnimationCss() {
    const card = document.getElementById(Styled.card_slider)
    card?.classList.remove(Styled.animation_slider)
    card?.classList.add(Styled.animation_exit)

    const animation = setTimeout(() => {
      card?.classList.remove(Styled.animation_exit)
      card?.classList.add(Styled.animation_slider)
    }, 1200)

    return () => {
      clearTimeout(animation)
    }
  }

  function handleToggleActiveFeedBack(direction: string) {
    handleApplyAnimationCss()
    const resultRemove = handleRemoveActiveFeedBack()
    const resultActive = handleAddActiveFeedBack(resultRemove, direction)
    setFeedBacks(resultActive)
  }

  function handleAddActiveFeedBack(
    resultRemove: FeedBacksProps,
    direction: string
  ) {
    let posActiveOld: number | null = null
    let posActive: number | null = null
    resultRemove.forEach((item: FeedBack, index: number) => {
      if (feedBackActive.id === item.id) {
        posActiveOld = index
      }
    })

    if (direction === "next") {
      if (posActiveOld < feedBacks.length - 1) {
        posActive = posActiveOld + 1
      } else {
        posActive = 0
      }
    } else {
      if (posActiveOld > 0) {
        posActive = posActiveOld - 1
      } else {
        posActive = feedBacks.length - 1
      }
    }

    const result = resultRemove.map((feed: FeedBack, index: number) => {
      if (index === posActive) {
        const actived = {
          name: feed.name,
          feedBack: feed.feedBack,
          id: feed.id,
          date: feed.date,
          isActive: true
        }

        setFeedBackActive(actived)
        return actived
      } else {
        return {
          name: feed.name,
          feedBack: feed.feedBack,
          id: feed.id,
          date: feed.date,
          isActive: feed.isActive
        }
      }
    })

    return result
  }

  function handleRemoveActiveFeedBack() {
    const result = feedBacks.map((feed: FeedBack) => {
      if (feed.isActive) {
        return {
          name: feed.name,
          feedBack: feed.feedBack,
          id: feed.id,
          date: feed.date,
          isActive: false
        }
      } else {
        return {
          name: feed.name,
          feedBack: feed.feedBack,
          id: feed.id,
          date: feed.date,
          isActive: feed.isActive
        }
      }
    })

    return result
  }

  async function handleGetWebsiteSettings() {
    const firestoreRef = doc(getFirestore(), "landing-page", "websiteSettings")
    await getDoc(firestoreRef)
      .then(snapshot => {
        if (snapshot.exists()) {
          setWebsiteSettings(snapshot.data())
        }

        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        toast.error("Ops! Algo deu errado.")
      })
  }

  async function handleDeleteImageFromFirestore(ref: string) {
    const firestoreRef = doc(getFirestore(), "landing-page", "websiteSettings")

    await updateDoc(firestoreRef, {
      [ref]: {
        name: "",
        file: null,
        url: "",
        ref
      }
    })
  }

  function handleDeleteImage(value: imgProps) {
    const storageRef = ref(getStorage(), `websiteImages/${value.name}`)
    deleteObject(storageRef)
      .then(async () => {
        const altered: webSiteProps = {
          ...websiteSettings,
          [value.ref]: {
            name: "",
            file: null,
            url: "",
            ref: value.ref
          }
        }

        handleDeleteImageFromFirestore(value.ref)
          .then(() => {
            setWebsiteSettings(altered)
          })
          .catch(() => {
            setWebsiteSettings(altered)
          })
      })
      .catch(error => {
        console.log(error)
        handleDeleteImageFromFirestore(value.ref)
      })
  }

  function handleRemoveFromArray(
    state: FeedBacksProps,
    setState: React.Dispatch<React.SetStateAction<FeedBacksProps>>,
    id: string
  ) {
    let newArray: FeedBacksProps = []

    state.forEach(item => {
      if (item.id !== id) {
        newArray.push(item)
      }
    })

    setState(newArray)
  }

  async function handleDeleteFeedback(id: string) {
    await deleteDoc(doc(getFirestore(), "feedBacks", id))
      .then(() => {
        handleRemoveFromArray(feedBacks, setFeedBacks, id)
        toast.success("Deletado com sucesso!")
      })
      .catch(error => {
        console.log(error)
        toast.error("Ops! Algo deu errado.")
      })
  }

  function handleGenerationUrlWhatsapp(props: ContactProps) {
    const link = `https://api.whatsapp.com/send?phone=${websiteSettings.whatsapp}
        &text=
        Olá me chamo ${props?.name},
        ${props?.subject}, meu email é ${props?.email}
        `

    return link
  }

  function handleClearInputs() {
    setWebsiteSettings(settingsDefault)
  }

  return (
    <LandingContext.Provider
      value={{
        signed,
        websiteSettings,
        feedBacks,
        loading,
        feedBackActive,
        controllerStop,
        setWebsiteSettings,
        setSigned,
        handleSignIn,
        handleCheckedLocalStorage,
        handleSignOut,
        handleFormatText,
        handleAddFeedBacks,
        handleUploadImage,
        handleSaveSettingsWebsite,
        handleGetFeedBacks,
        setFeedBacks,
        handleGetWebsiteSettings,
        handleDeleteImage,
        handleDeleteFeedback,
        setLoading,
        handleToggleActiveFeedBack,
        handleGenerationUrlWhatsapp,
        handleClearInputs,
        setControllerStop,
        handleToggleControllerStop
      }}
    >
      {children}
    </LandingContext.Provider>
  )
}

export const useLandingContext = () => {
  const context = useContext(LandingContext)

  if (context === undefined) {
    throw new Error("Erro ao usar os dados fora do contexto!")
  }

  return context
}

export default LandingProvider
